import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Column, Row} from "simple-flexbox";
import CustomButton from "../../common/components/CustomButton";
import CustomInput from "../../common/components/CustomInput";
import CustomTextArea from "../../common/components/CustomTextArea";
import bannerService from "../../services/banner";
import Utility from "../../utility";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ComponentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: max-content;
  justify-content: space-between;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 22px;
  align-items: center;
`;

const InputRow = styled(Row)`
  padding: 30px 20px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: solid 1px #dfe1e6;
  border-radius: 6px;
  background-color: #fafbfc;
  width: 80%;
`;

const InputColumn = styled(Column)`
  width: 50%;
  gap: 25px;
  font-size: 18px !important;
  align-items: center;
`;

function SettingsComponent(props) {
    const [goldPriceHYD, setGoldPriceHYD] = useState()
    const [goldPriceMTPLY, setGoldPriceMTPLY] = useState()
    const [goldPriceKRTL, setGoldPriceKRTL] = useState()
    const [goldPriceNIRML, setGoldPriceNIRML] = useState()
    const [goldARMR, setGoldARMR] = useState()
    const [goldNZMBD, setGoldNZMBD] = useState()
    const [goldBMGL, setGoldBMGL] = useState()
    const [goldJGTYL, setGoldJGTYL] = useState()
    const [silverPrice, setSilverPrice] = useState(props?.state?.silverPrice)
    const [notifications, setNotifications] = useState("")
    const setGoldData = () => {
        setGoldPriceHYD(props?.state?.goldData?.goldHYD)
        setGoldPriceMTPLY(props?.state?.goldData?.goldMTPLY)
        setGoldPriceKRTL(props?.state?.goldData?.goldKRTL)
        setGoldPriceNIRML(props?.state?.goldData?.goldNIRML)
        setGoldARMR(props?.state?.goldData?.goldARMR)
        setGoldJGTYL(props?.state?.goldData?.goldJGTYL)
        setGoldBMGL(props?.state?.goldData?.goldBMGL)
        setGoldNZMBD(props?.state?.goldData?.goldNZMBD)
    }
    useEffect(() => {
        setGoldData()
    }, [props.state.goldData])

    useEffect(() => {
        setSilverPrice(props.state.silverPrice)
    }, [props.state.silverPrice])

    const onSubmitGoldUpdate = async () => {
        let [err] = await Utility.parseResponse(bannerService.updateGoldPrice({
            gold: goldPriceHYD,
            goldHYD: goldPriceHYD,
            goldMTPLY: goldPriceMTPLY,
            goldKRTL: goldPriceKRTL,
            goldNIRML: goldPriceNIRML,
            goldARMR: goldARMR,
            goldNZMBD: goldNZMBD,
            goldBMGL: goldBMGL,
            goldJGTYL: goldJGTYL,
            silver: silverPrice
        }));
        if (err)
            return Utility.apiFailureToast("Unable to update Gold Price");
        Utility.apiSuccessToast("Metal Price updated");
    };

    const sendNotifications = async () => {
        let [err] = await Utility.parseResponse(bannerService.sendBulkNotif({
            description: notifications
        }));
        if (err)
            return Utility.apiFailureToast("Unable to send Notifications");
        else Utility.apiSuccessToast("Notification sent successfully");
    };

    return (
        <MainContainer>
            <ComponentHeader>
                <SearchContainer>
                    Settings and Utilities
                </SearchContainer>
            </ComponentHeader>
            <div style={{marginTop: '30px'}}/>
            <SearchContainer>
                Live Price
            </SearchContainer>
            <InputRow>
                <InputColumn>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm HYD</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm KRTL</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm MTPLY</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm NIRML</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm ARMR</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm NZMBD</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm BMGL</span>
                    <span style={{marginTop: '8px'}}>Gold / 10 Gm JGTYL</span>
                    <span style={{marginTop: '8px'}}>Silver / KiloGram</span>
                    <CustomButton text="Update" onClick={onSubmitGoldUpdate}/>
                </InputColumn>
                <InputColumn>
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldPriceHYD}
                        onChange={(e) => setGoldPriceHYD(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldPriceKRTL}
                        onChange={(e) => setGoldPriceKRTL(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldPriceMTPLY}
                        onChange={(e) => setGoldPriceMTPLY(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldPriceNIRML}
                        onChange={(e) => setGoldPriceNIRML(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldARMR}
                        onChange={(e) => setGoldARMR(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldNZMBD}
                        onChange={(e) => setGoldNZMBD(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldBMGL}
                        onChange={(e) => setGoldBMGL(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={goldJGTYL}
                        onChange={(e) => setGoldJGTYL(e.target.value)}
                    />
                    <CustomInput
                        type="number"
                        placeholder="Price"
                        required={true}
                        value={silverPrice}
                        onChange={(e) => setSilverPrice(e.target.value)}
                    />
                </InputColumn>
            </InputRow>
            <div style={{marginTop: '30px'}}/>
            <SearchContainer> Push Notification </SearchContainer>
            <InputRow>
                <InputColumn>
                    <span style={{marginTop: '10px'}}>Description</span>
                    <CustomButton text="Send" onClick={sendNotifications}/>
                </InputColumn>
                <InputColumn>
                    <CustomTextArea
                        placeholder="Enter Notification Text"
                        required={true}
                        value={notifications}
                        onChange={(e) => setNotifications(e.target.value)}
                    />
                </InputColumn>
            </InputRow>
        </MainContainer>
    );
}

export default SettingsComponent;
